import React, { useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Mail, X } from "lucide-react";
import { toast } from "sonner";

/**
 * Sticky banner shown on authenticated pages while the user hasn't verified their email yet.
 * Dismissable for the session via localStorage flag.
 */
export const EmailVerifyBanner = () => {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem("hide_verify_banner") === "1"; } catch { return false; }
  });

  if (!user || user.email_verified || hidden) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success(`Email envoyé à ${user.email} 🌸`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Impossible d'envoyer pour le moment");
    } finally {
      setSending(false);
    }
  };

  const close = () => {
    try { sessionStorage.setItem("hide_verify_banner", "1"); } catch {}
    setHidden(true);
  };

  return (
    <div
      data-testid="email-verify-banner"
      className="bg-[#FFF5E0] border-y border-[#FFD166] text-[#1A2A40]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-3 flex flex-wrap items-center gap-3 text-sm">
        <Mail className="w-4 h-4 shrink-0 text-[#E94A3F]" />
        <span className="flex-1 min-w-[200px]">
          <strong>Confirme ton email</strong> pour sécuriser ton compte,{" "}
          un lien t'a été envoyé à <strong>{user.email}</strong>.
        </span>
        <button
          onClick={resend}
          disabled={sending}
          data-testid="resend-verification-btn"
          className="px-3 py-1.5 bg-[#1A2A40] text-white text-xs font-bold rounded-md hover:bg-[#0d1825] transition-colors disabled:opacity-60"
        >
          {sending ? "Envoi…" : "Renvoyer l'email"}
        </button>
        <button
          onClick={close}
          aria-label="Masquer"
          data-testid="close-verify-banner-btn"
          className="p-1.5 text-[#A0AEC0] hover:text-[#1A2A40] transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default EmailVerifyBanner;
